export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-05-07 at 19.29.13 - Rithika G.636943a9.jpeg";